import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalCriminalConvictionsModel} from './types';
import legalNonCriminalCourtActionsItemValidator from './validators/item';
import legalCriminalConvictionsItemValidator from './validators/item';

const legalCriminalConvictionsValidator: ValidateJSModel<LegalCriminalConvictionsModel> = {
 List: {
    presence: true,
    branchCollection: { validator: legalCriminalConvictionsItemValidator },
  },
};

export default legalCriminalConvictionsValidator;
